module.exports = __webpack_public_path__ + "img/skype.504f984d.svg";